<template>
  <b-list-group-item
    class="d-flex justify-content-between align-items-center font-weight-bold"
    href="/Kalender"
    style="color: #00C851;"
  >
    <h5>{{ event.name }}</h5>
    <b-badge
      pill
    >
      {{ formatDate(event.start) }}
    </b-badge>
  </b-list-group-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CalendarListEntry',
  data () {
    return {
      eventId: parseInt(this.$vnode.key)
    }
  },
  computed: {
    ...mapGetters([
      'getLatestEventsById'
    ]),
    event () {
      return this.getLatestEventsById(this.eventId)
    }
  },
  methods: {
    formatDate (oldDate) {
      const date = new Date(oldDate)
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1

      return day + '.' + month + '.' + date.getFullYear()
    }
  }
}
</script>

<style scoped>
.badge {
  flex: inherit !important;
  background-color: #00C851;
}
</style>
